import { render, staticRenderFns } from "./keyboxLogs.vue?vue&type=template&id=60407c36&"
import script from "./keyboxLogs.vue?vue&type=script&lang=js&"
export * from "./keyboxLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports